<template>
<div class="order-wrapper">
  <portal target-el="#filter">
    <div class="sub-header">
      <div class="header-item">
        <Breadcrumb type="flex" separator-class="el-icon-arrow-right">
          <breadcrumb-item :to="{ path: '/mdm/vehicledetail' }">{{$t('MDM_VEHICLE_DETAILS')}}</breadcrumb-item>
          <breadcrumb-item>{{$t('MDM_DETAILS')}}</breadcrumb-item>
        </Breadcrumb>
      </div>
    </div>
  </portal>
  <div>
    <ElTabs class="tab-default tab-sm text-dark" v-model="detailsTab" v-if="nonEditableData">
      <Tab-pane :label="$t('MDM_DETAILS')" name="details">
        <div class="tab-content">
          <h5 class="d-flex align-items-center">
            <span class="text-blue-dark1 text-md">{{ nonEditableData.transporter }}</span>
            <div v-if="$hasPermission('is_vehicle_type_editable') || $hasPermission('is_vehicle_status_editable')" class="ml-auto">
              <div v-if="!updateButtonDisabled">
                <Button type="secondary" size="small" @click="updateVehicleType">{{ $t('MDM_UPDATE') }}</Button>
              </div>
              <div v-else class="action-disabled">
                <Tooltip popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
                  <div slot="content">{{ $t('MANDATORY_FIELDS_REQUIRED') }}</div>
                  <span class="pointer">
                    <Button type="secondary" size="small" disabled>{{ $t('MDM_UPDATE') }}</Button>
                  </span>
                </Tooltip>
              </div>
            </div>
          </h5>

          <Row :gutter="10">
            <Col :span="12">
              <Form :inline="true" class="form-default form-triple">
                <FormItem :label="$t('MDM_VEHICLE_NUMBER')" disabled>
                  <Input placeholder="Enter Number" type="text" v-model="nonEditableData.number"></Input>
                </FormItem>
                <FormItem :label="$t('MDM_VEHICLE_NAME')" :disabled="!$hasPermission('is_vehicle_type_editable')">
                  <div v-if="isOnlyChangeTruckState || hideAllActions || isEximIndent">
                    {{ currentIndent.deliveryType }}
                  </div>

                  <Select
                    v-if="$hasPermission('is_vehicle_type_editable')"
                    v-model="nonEditableData.vehicle_type"
                    filterable
                    :value = "nonEditableData.vehicle_type"
                    size="mini"
                    popper-class="select-dark-dropdown text-right"
                    class="select-default select-dark"
                    placeholder="search"
                    :disabled="!$hasPermission('is_vehicle_type_editable')"
                  >
                    <Option v-for="(item, index) in vehicletypeList" :key="`${item}-${index}`" :value="item">
                    </Option>
                  </Select>
                  <Input v-else :placeholder="$t('INDENT_CHOOSE_VEHICLE')" type="text" v-model="nonEditableData.vehicle_type"></Input>

                </FormItem>
                <FormItem :label="$t('MDM_VEHICLE_MODEL')" disabled>
                  <Input placeholder="Enter Model" type="text" v-model="nonEditableData.vehicle_model"></Input>
                </FormItem>
                  <FormItem :label="$t('MDM_VEHICLE_BS_STANDARD')" :disabled="!$hasPermission('is_vehicle_status_editable')">
                  <Select
                    :disabled="!$hasPermission('is_vehicle_status_editable')"
                    class="select-default no-bg"
                    size="mini"
                    v-model="nonEditableData.vehicles[0].bharat_stage"
                    >
                    <Option v-for="item in bharatStageOptions"
                    :key="item.id" :label="item.label"
                    :value="item.name" />
                  </Select>
                </FormItem>
                <FormItem v-if="$hasFeature('vahan_validation') || $hasFeature('vahan_validation_ftl') || $hasFeature('vahan_validation_ptl')" :label="$t('MDM_FUEL_TYPE')" disabled>
                  <Input :value="nonEditableData.vehicles[0].fuel_type" disabled />
                </FormItem>
                <FormItem :label="$t('INDENT_RC')" :required="isRCMandatory">
                  <Input :placeholder="$t('INDENT_RC_SAMPLE')" v-model="nonEditableData.vehicles[0].rc_number" :disabled="!$hasPermission('is_vehicle_type_editable')" />
                </FormItem>
                <FormItem :label="$t('INDENT_TARE_UNLADEN_WEIGHT')" :required="isRCMandatory">
                  <Input :placeholder="$t('INDENT_ENTER_TARE_UNLADEN_WEIGHT')" v-model.number="nonEditableData.vehicles[0].tare_unladen_weight" type='number' :disabled="!$hasPermission('is_vehicle_type_editable')"/>
                </FormItem>
                <FormItem :label="$t('INDENT_GROSS_VEHICLE_WEIGHT')" :required="isRCMandatory">
                  <Input :placeholder="$t('INDENT_ENTER_GROSS_VEHICLE_WEIGHT')" v-model.number="nonEditableData.vehicles[0].gross_vehicle_weight" type='number' :disabled="!$hasPermission('is_vehicle_type_editable')"/>
                </FormItem>
                <template v-if="isDestinationDepotEnabled">
                  <FormItem :label="$t('MDM_MATERIAL_TYPE')">
                    <Input :placeholder="$t('MDM_ENTER_MATERIAL_TYPE')" v-model="nonEditableData.vehicles[0].material_type" :disabled="!$hasPermission('is_vehicle_type_editable')"/>
                  </FormItem>
                </template>
              </Form>
              <div class="mt-10" v-if="nonEditableData.number">
                <p class="text-xs text-bold mt-0">{{$t('INDENT_RC_ATTACHMENT')}}<span v-if="isRCAttachmentMandatory" style="color:#ed4014;"> *</span></p>
                <AttachmentsPopup
                  :attachments="rcAttachmentsList"
                  :maxAllowed="rcAttachmentLimit"
                  :multiple="true"
                  :allowDelete="$hasPermission('is_vehicle_type_editable')"
                  :disableUpload="!$hasPermission('is_vehicle_type_editable')"
                  @addAttachments="addRcAttachment"
                  @removeAttachments="removeRcAttachment"
                />
              </div>
            </Col>
            <Col :span="12">
              <Form :inline="true" class="form-default form-triple">
                <FormItem :label="$t('MDM_TRANSPORTER')" disabled>
                  <Input placeholder="Enter Transporter" type="text" v-model="nonEditableData.transporter"></Input>
                </FormItem>
                <FormItem :label="$t('MDM_CHASIS_NUMBER')" disabled>
                  <Input placeholder="Enter Chasis Number" type="text" v-model="nonEditableData.chasis_number"></Input>
                </FormItem>
                <FormItem :label="$t('MDM_VEHICLE_STATUS')" :disabled="!$hasPermission('is_vehicle_status_editable') || isPimcExpired">
                  <Select
                    :disabled="!$hasPermission('is_vehicle_status_editable') || isPimcExpired"
                    class="select-default no-bg"
                    size="mini"
                    value-key="id"
                    v-model="nonEditableData.vehicles[0].vehicle_status"
                    @change="updateVehicleStatus($event)">
                    <Option v-for="item in VehicleStatus"
                    :key="item.id" :label="item.label"
                    :value="item.name" />
                  </Select>
                </FormItem>
                <FormItem :label="$t('MDM_PIMC_EXPIRY_DATE')" disabled>
                  <DatePicker
                    v-model="nonEditableData.vehicles[0].pimc_expiry_date"
                    type="date"
                    placeholder="Select PIMC Expiry Date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :disabled="true"
                    size="mini"
                    class="date-picker-default">
                  </DatePicker>
                </FormItem>
              </Form>
            </Col>
          </Row>
        </div>
        <div class="tab-content mt-20">
          <h5 class="d-flex align-items-center">
            <span class="text-blue-dark1 text-md">{{$t('MDM_DEPOT_AVAILABILITY')}}</span>
            <Button type="secondary" size="small" class="ml-auto" v-if="depotEditable" :disabled="!hasUnsavedDepot" @click="updateVehicleDetails">{{$t('MDM_SAVE')}}</Button>
          </h5>
          <div class="mt-10 table-with-add">
            <div class="add-block" v-if="depotEditable" @click="addDepot"> {{$t('MDM_ADD_DEPOT')}} </div>
            <Table
              :data="depotWiseData"
              :stripe="true"
              class="table-striped bordered mt-10"
              aria-describedby="depotWiseData"
              >
              <table-column label="Depot" width="200" v-if="showAddDepot">
                  <template slot-scope="scope">
                    <Select class="select-default p-0 no-bg"
                        :disabled="DepotSelectionFlag(scope.row.depot.name, scope.row.disabled)"
                        :value="scope.row.depot.name" size="mini"
                        value-key="id" placeholder="Select"
                        @change="updateDepot($event, scope.$index)" >
                        <Option v-for="item in depots"
                            :key="item.id" :label="item.name"
                            :value="item" />
                    </Select>
                  </template>
              </table-column>
              <table-column :label="$t('MDM_AVAILABILITY')" width="150" v-if="showAddDepot">
                <template slot-scope="scope">
                  <SwitchBtn
                    :disabled="vehicleStatusCheck"
                    v-model="scope.row.is_vehicle_available"
                    @change="hasUnsavedDepot = true"
                    label="right"
                    size="small"
                    active-text="YES"
                    inactive-text="NO"
                    class="default-switch">
                  </SwitchBtn>
                </template>
              </table-column>
              <table-column :label="$t('MDM_DESTINATION_DEPOT')" width="250" v-if="isDestinationDepotEnabled && showAddDepot">
                <template slot-scope="scope">
                    <Select
                      v-model="scope.row.selectedDestinationDepotIds"
                      multiple
                      filterable
                      :disabled="!$hasPermission('is_vehicle_type_editable')"
                      class="select-default p-0 no-bg"
                      size="mini"
                      @change="onDestinationDepotsChange($event, scope.$index)">
                      <Option v-for="depot in allDepots" :key="depot.id" :label="depot.name" :value="depot.id" />
                    </Select>
                </template>
              </table-column>
              <table-column :label="$t('MDM_STATUS')">
                <template slot-scope="scope">
                    <span> {{scope.row.status}} </span>
                </template>
              </table-column>
              <table-column :label="$t('MDM_FLEET_TYPE')" width="200">
                  <template slot-scope="scope">
                    <Select class="select-default p-0 no-bg"
                        :disabled= "vehicleStatusCheck"
                        :value="getFleetTypeName(scope.row.fleet_type)" size="mini"
                        value-key="id" :placeholder="$t('ADMIN_SELECT_TYPE')"
                        @change="updateFleetType($event, scope.$index)">
                        <Option v-for="item in FleetTypes"
                            :key="item.id" :label="item.label"
                            :value="item.name" />
                    </Select>
                  </template>
              </table-column>
              <table-column :label="$t('MDM_TARE_WEIGHT')" width="100">
                <template slot-scope="scope">
                  <Input class="input-blank p-0"
                    :disabled="vehicleStatusCheck"
                    size="mini" type="number"
                    v-model="scope.row.tare_weight"
                    @input="hasUnsavedDepot = true" />
                </template>
              </table-column>
              <table-column :label="getVehicleDimensionsLabel('length')" width="100">
                <template slot-scope="scope">
                  <Input class="input-blank p-0"
                    :disabled="vehicleStatusCheck"
                    size="mini" type="number"
                    v-model="scope.row.vehicle_length"
                    @input="onDimensionChange(scope.row); hasUnsavedDepot = true" />
                </template>
              </table-column>
              <table-column :label="getVehicleDimensionsLabel('width')" width="100">
                <template slot-scope="scope">
                  <Input class="input-blank p-0"
                    :disabled="vehicleStatusCheck"
                    size="mini" type="number"
                    v-model="scope.row.vehicle_width"
                    @input="onDimensionChange(scope.row); hasUnsavedDepot = true" />
                </template>
              </table-column>
              <table-column :label="getVehicleDimensionsLabel('height')" width="100">
                <template slot-scope="scope">
                  <Input class="input-blank p-0"
                    :disabled="vehicleStatusCheck"
                    size="mini" type="number"
                    v-model="scope.row.vehicle_height"
                    @input="onDimensionChange(scope.row); hasUnsavedDepot = true" />
                </template>
              </table-column>
              <table-column :label="$t('MDM_WEIGHT_CAPACITY')" width="200">
                <template slot-scope="scope">
                  <Input class="input-blank p-0"
                    size="mini" type="number"
                    v-model="scope.row.vehicle_weight_capacity"
                    @input="hasUnsavedDepot = true" />
                </template>
              </table-column>
              <table-column :label="$t('MDM_UOM')" width="">
                <template slot-scope="scope">
                  <Input class="input-blank p-0"
                    :disabled="vehicleStatusCheck"
                    size="mini" type="text"
                    v-model="scope.row.vehicle_uom"
                    @input="hasUnsavedDepot = true" />
                </template>
              </table-column>
              <table-column :label="$t('MDM_FILLED_WEIGHT')" width="100">
                <template slot-scope="scope">
                  <Input class="input-blank p-0"
                    :disabled="vehicleStatusCheck"
                    size="mini" type="number"
                    v-model="scope.row.vehicle_filled_weight"
                    @input="hasUnsavedDepot = true" />
                </template>
              </table-column>
              <table-column :label="$t('MDM_GROSS_WEIGHT')" width="100">
                <template slot-scope="scope">
                  <Input class="input-blank p-0"
                    :disabled="vehicleStatusCheck"
                    size="mini" type="number"
                    v-model="scope.row.vehicle_gross_weight"
                    @input="hasUnsavedDepot = true" />
                </template>
              </table-column>
              <table-column :label="`${$t('MDM_PACKAGE_VOLUME')} (${preferredVolumeUnit})`" width="">
                <template slot-scope="scope">
                  <Input class="input-blank p-0"
                    :disabled="vehicleStatusCheck"
                    size="mini" type="number"
                    v-model="scope.row.vehicle_volume"
                    @input="onVolumeChange(scope.row); hasUnsavedDepot = true" />
                </template>
              </table-column>
            </Table>
          </div>
        </div>
      </Tab-pane>
    </ElTabs>
  </div>
</div>
</template>

<script>
import { cloneDeep } from 'lodash';
import moment from 'moment';
import { FleetTypes, VehicleStatus, status, bharatStageOptions, fuelTypeOptions, DEFAULT_RC_DOCUMENTS_LIMIT } from '../../../constants/mdm';
import { vehicleDimensionUnits, VolumeUnits } from 'pando-constants';
import convert from 'convert-units';
import AttachmentsPopup from '../../AttachmentsPopup';

export default {
  components: { AttachmentsPopup },
  props: {
    data: {
      type: Array,
      required: true,
    },
    depots: {
      type: Array,
      default: false,
    },
    allDepots: {
      type: Array,
      default: () => [],
    },
    showAddDepot: {
      type: Boolean,
    },
    vehicleList:  {
     type:Array,
    },
    configurations: {
      type: Object,
      default: () => ({}),
    },
    isDestinationDepotEnabled: {
      type: Boolean,
      default: false,
    },
    isVehicleTypeEditable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      vehicle_number: null,
      detailsTab: 'details',
      localData: null,
      vehicletypeList:[],
      localData: [],
      rcAttachmentsList: [],
      FleetTypes,
      status,
      emptyTableData: {
        is_vehicle_available: false,
        depot: { name: '', id: '' },
        destination_depots: [{ name: '', id: ''}],
        status: 1,
        tare_weight: 0,
        vehicle_length: 0,
        vehicle_width: 0,
        vehicle_height: 0,
        vehicle_weight_capacity: 0,
        vehicle_uom: 'KG',
        vehicle_filled_weight: 0,
        vehicle_gross_weight: 0,
        vehicle_volume: 0,
        disabled: false,
        vehicle_status: status.ACTIVE,
      },
      VehicleStatus,
      bharatStageOptions,
      fuelTypeOptions,
      depotEditable: null,
      hasUnsavedDepot: false,
    };
  },
  computed : {
    nonEditableData() {
      return this.localData && this.localData[0] && this.localData[0].vehicles && this.localData[0].vehicles[0] ? this.localData[0] : null;
    },
    vehicleStatusCheck() {
      return this.nonEditableData && this.nonEditableData.vehicles && this.nonEditableData.vehicles[0]
        ? this.nonEditableData.vehicles[0].vehicle_status === status.INACTIVE
        : false;
    },
    updateButtonDisabled() {
      if (!this.isVehicleTypeEditable) return false;
      if (this.isRCAttachmentMandatory && (!this.rcAttachmentsList || !this.rcAttachmentsList.length)) return true;
      if (!this.isRCMandatory) return false;
      if (!this.nonEditableData || !this.nonEditableData.vehicles) return true;
      const vehicle = this.nonEditableData.vehicles[0];
      if (!vehicle || 
        !vehicle.rc_number || 
        !vehicle.rc_number.length ||
        vehicle.tare_unladen_weight === null ||
        vehicle.tare_unladen_weight === undefined ||
        vehicle.tare_unladen_weight === '' ||
        vehicle.tare_unladen_weight === 0 ||
        vehicle.gross_vehicle_weight === null ||
        vehicle.gross_vehicle_weight === undefined ||
        vehicle.gross_vehicle_weight === '' ||
        vehicle.gross_vehicle_weight === 0 || 
        !vehicle.material_type ) return true;
      return false;
    },
    isRCMandatory() {
      return this.$hasFeature('mandatory_rc_number');
    },
    isRCAttachmentMandatory() {
      return this.$hasFeature('mandatory_rc_attachment');
    },
    rcAttachmentLimit() {
      const limit = (this.configurations && this.configurations.attachmentsLimit
        && this.configurations.attachmentsLimit.rc_documents) || DEFAULT_RC_DOCUMENTS_LIMIT;
      return limit;
    },
    isPimcExpired() {
      if (!this.nonEditableData || !this.nonEditableData.vehicles || !this.nonEditableData.vehicles[0] || !this.nonEditableData.vehicles[0].pimc_expiry_date) {
        return false;
      }
      const pimcDate = new Date(this.nonEditableData.vehicles[0].pimc_expiry_date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return pimcDate < today;
    },
    prePopulate() {
      const vehicleLength = this.localData && this.localData[0] &&
        this.localData[0].vehicles.length;
      const lastUpdated = this.localData && this.localData[0] &&
        this.localData[0].vehicles[vehicleLength - 1];
      const prePopulatedData = {
        tare_weight: lastUpdated.tare_weight,
        vehicle_length: lastUpdated.vehicle_length,
        vehicle_width: lastUpdated.vehicle_width,
        vehicle_height: lastUpdated.vehicle_height,
        vehicle_weight_capacity: lastUpdated.vehicle_weight_capacity,
        vehicle_filled_weight: lastUpdated.vehicle_filled_weight,
        vehicle_gross_weight: lastUpdated.vehicle_gross_weight,
        vehicle_volume: lastUpdated.vehicle_volume,
        fleet_type: lastUpdated.fleet_type,
        vehicle_status: lastUpdated.vehicle_status,
        material_type: lastUpdated.material_type,
      }
      return Object.assign(this.emptyTableData, prePopulatedData);
    },
    depotWiseData() {
        const depotData = this.localData && this.localData[0].vehicles && this.localData[0].vehicles.map((vehicle) => {
            const depotDetails = vehicle.depot_id || vehicle.depot;
            const destinationDepotIds = (vehicle.destination_depots || []).map(d => d._id || d.id || d);
            const obj = {
                depot: depotDetails ? { name: depotDetails.name, id: depotDetails._id || depotDetails.id } : { name: '', id: '' },
                selectedDestinationDepotIds: destinationDepotIds,
                is_vehicle_available: vehicle.vehicle_status === status.ACTIVE ? vehicle.is_vehicle_available : false,
                tare_weight: vehicle.tare_weight || 0,
                vehicle_length: vehicle.vehicle_length || 0,
                vehicle_width: vehicle.vehicle_width || 0,
                vehicle_height: vehicle.vehicle_height || 0,
                vehicle_weight_capacity: vehicle.vehicle_weight_capacity || 0,
                vehicle_uom: vehicle.vehicle_uom || 'KG',
                vehicle_filled_weight: vehicle.vehicle_filled_weight || 0,
                vehicle_gross_weight: vehicle.vehicle_gross_weight || 0,
                vehicle_volume: vehicle.vehicle_volume || 0,
                fleet_type: vehicle.fleet_type,
                status: vehicle.status === 1 ? 'Blacklisted' : 'Unblacklisted',
                vehicle_status: vehicle.vehicle_status || status.ACTIVE,
            };
            return Object.assign(vehicle, obj);
        });
        return depotData;
    },
    vehicleDimensionsUOM() {
      return this.configurations.vehicle_dimensions_uom || vehicleDimensionUnits.CM;
    },
    preferredVolumeUnit() {
      return this.configurations.preferred_volume_unit || VolumeUnits.CFT;
    }
  },
  created(){
    this.depotEditable = this.showAddDepot
      && this.data[0] && this.data[0].vehicles && this.data[0].vehicles[0]
    ? this.data[0].vehicles[0].vehicle_status === status.ACTIVE
    : false;
    this.localData = cloneDeep(this.data);
    this.vehicleList.map((value)=>{
     this.vehicletypeList.push(value.name);
    });
    const rcDocs = (this.nonEditableData && this.nonEditableData.vehicles
      && this.nonEditableData.vehicles[0] && this.nonEditableData.vehicles[0].rc_attachments) || [];
    this.rcAttachmentsList = rcDocs.map(doc => ({ id: doc.id, name: doc.name, url: doc.url }));
  },
  methods: {
    async addRcAttachment(file) {
      if (!this.nonEditableData || !this.nonEditableData.number) return;
      try {
        const formData = new FormData();
        formData.append('attachment', file.raw);
        const result = await this.$store.dispatch('order/addAttachment', formData);
        if (result && result.id) {
          this.rcAttachmentsList.push({
            id: result.id,
            name: result.name || file.name,
            url: result.attachment_url || '',
          });
        } else {
          this.$Message.error('Upload failed');
        }
      } catch (err) {
        const msg = err && err.data && err.data.errors && err.data.errors[0] && err.data.errors[0].message;
        this.$Message.error(msg || 'Upload failed');
      }
    },
    removeRcAttachment(file) {
      this.rcAttachmentsList = this.rcAttachmentsList.filter(a => a.id !== file.id);
    },
    onDimensionChange(row) {
      // Clear volume when dimensions are edited
      row.vehicle_volume = null;
      
      if (!row.vehicle_length || !row.vehicle_width || !row.vehicle_height) {
        return;
      }

      const preferredUnit = this.preferredVolumeUnit;
      
      if (preferredUnit === VolumeUnits.CCM) {
        const lengthCm = convert(row.vehicle_length).from(this.vehicleDimensionsUOM).to(vehicleDimensionUnits.CM);
        const widthCm = convert(row.vehicle_width).from(this.vehicleDimensionsUOM).to(vehicleDimensionUnits.CM);
        const heightCm = convert(row.vehicle_height).from(this.vehicleDimensionsUOM).to(vehicleDimensionUnits.CM);
        row.vehicle_volume = (lengthCm * widthCm * heightCm).toFixed(2);
      } else if (preferredUnit === VolumeUnits.CBM) {
        const lengthM = convert(row.vehicle_length).from(this.vehicleDimensionsUOM).to('m');
        const widthM = convert(row.vehicle_width).from(this.vehicleDimensionsUOM).to('m');
        const heightM = convert(row.vehicle_height).from(this.vehicleDimensionsUOM).to('m');
        row.vehicle_volume = (lengthM * widthM * heightM).toFixed(2);
      } else {
        const lengthFt = convert(row.vehicle_length).from(this.vehicleDimensionsUOM).to(vehicleDimensionUnits.FT);
        const widthFt = convert(row.vehicle_width).from(this.vehicleDimensionsUOM).to(vehicleDimensionUnits.FT);
        const heightFt = convert(row.vehicle_height).from(this.vehicleDimensionsUOM).to(vehicleDimensionUnits.FT);
        row.vehicle_volume = (lengthFt * widthFt * heightFt).toFixed(2);
      }
    },
    onVolumeChange(row) {
      // Clear dimensions when volume is directly edited
      if (row.vehicle_volume && row.vehicle_volume > 0) {
        row.vehicle_length = null;
        row.vehicle_width = null;
        row.vehicle_height = null;
      }
    },
    getVehicleDimensionsLabel(type) {
      return this.$t(`MDM_${type.toUpperCase()}_IN_${this.vehicleDimensionsUOM.toUpperCase()}`);
    },
    DepotSelectionFlag(depotName, flag) {
      if(this.nonEditableData && this.nonEditableData.vehicles && this.nonEditableData.vehicles[0] && this.nonEditableData.vehicles[0].vehicle_status === status.INACTIVE) {
        return true;
      } else {
        return depotName !== '' ? flag : false;
      }
    },
    getFleetTypeName(fleetType) {
      const fleet = FleetTypes.find((FleetType) => FleetType.name === fleetType);
      return fleet ? fleet.label : null;
    },
    addDepot() {
        const arr = [];
        this.localData.forEach((value) => {
            const obj = {
            number: value.vehicles && value.vehicles[0].number,
            type: value.vehicles[0].type || {},
            vehicle_model: value.vehicles[0].vehicle_model || '-',
            transporter: (value.vehicles[0].transporter_id &&
                value.vehicles[0].transporter_id.vname) ?
                value.vehicles[0].transporter_id.vname : '-',
            chasis_number: value.vehicles[0].chasis_number || '-',
            rc_number: value.vehicles[0].rc_number || '',
            tare_unladen_weight: value.vehicles[0].tare_unladen_weight || '',
            gross_vehicle_weight: value.vehicles[0].gross_vehicle_weight || '',
            material_type: value.vehicles[0].material_type || '',
            };
            arr.push(obj);
        });
        const newData = cloneDeep(this.prePopulate);
        this.localData[0].vehicles.unshift(Object.assign(newData, arr[0]));
        this.localData = cloneDeep(this.localData);
    },
    updateDepot(event, index) {
      this.localData[0].vehicles[index].depot = event;
      this.localData = cloneDeep(this.localData);
      this.hasUnsavedDepot = true;
    },
    updateFleetType(event, index) {
      this.localData[0].vehicles[index].fleet_type = event;
      this.localData = cloneDeep(this.localData);
      this.hasUnsavedDepot = true;
    },
    updateVehicleType() {
      if (!this.isVehicleTypeEditable) {
        this.$emit('updateVehicleDetails', this.localData);
        return;
      }
      const data = this.localData;
      if (this.rcAttachmentsList && this.rcAttachmentsList.length) {
        data[0].rc_attachment_ids = this.rcAttachmentsList.map(a => a.id);
      }
      this.$emit('updateVehicleType', data);
    },
    updateVehicleDetails() {
      this.$emit('updateVehicleDetails', this.localData);
      this.hasUnsavedDepot = false;
    },
    updateVehicleStatus(event) {
      if(event === status.INACTIVE) {
        this.depotEditable = false;
        this.localData[0].vehicles.forEach(data => {
          data.is_vehicle_available = false;
          data.vehicle_status = event;
        });
      } else {
        this.depotEditable = this.showAddDepot ? true : false;
        this.localData[0].vehicles.forEach(data => {
          data.vehicle_status = event;
        });
      }
      this.localData = cloneDeep(this.localData);
    },
    formatDate(dateString) {
      if (!dateString) return '';
      return moment(date).format('YYYY-MM-DD');
    },
    onDestinationDepotsChange(selectedIds, index) {
      if (!this.localData || !this.localData[0] || !this.localData[0].vehicles) return;
      const selectedDepots = this.allDepots.filter(d => selectedIds.includes(d.id));
      this.localData[0].vehicles[index].destination_depots = selectedDepots;
      this.localData = cloneDeep(this.localData);
      this.hasUnsavedDepot = true;
    },
  },
};
</script>

<style scoped>
.el-button:disabled {
  cursor: default !important;
}
</style>

